const getAPIQueryParam = includeConfig => {
  switch (includeConfig) {
    case 'zeroTransactions':
      return {
        queryParam: 'excludeZeroTransactions',
        value: false
      };
  }
};
const updateAPIParamsForIncludeConfig = queryParams => {
  const include = queryParams.include;

  // Exclude $0 transactions by default
  // https://www.figma.com/file/s7FuifD9t9mXTqdmjoBNdw/Partner-reports?type=design&node-id=9001-92018&mode=design&t=wasugjaRtYyfOHLP-0
  queryParams.excludeZeroTransactions = 'true';
  if (include) {
    if (Array.isArray(include)) {
      include.forEach(includeConfig => {
        const apiFilter = getAPIQueryParam(includeConfig.toString());
        if (apiFilter) {
          queryParams[apiFilter.queryParam] = apiFilter.value.toString();
        }
      });
    } else {
      const apiFilter = getAPIQueryParam(include);
      if (apiFilter) {
        queryParams[apiFilter.queryParam] = apiFilter.value.toString();
      }
    }
  }

  // remove the api query param for include since it is irrelevant to the API
  delete queryParams.include;
  return queryParams;
};
export const mapQueryParamsToApiParams = queryParams => {
  queryParams = updateAPIParamsForIncludeConfig(queryParams);
  return queryParams;
};